/** Возвращает ключ записи списка */
export const getRecordKey = (record: unknown, field = 'id'): string | undefined => {
    if (typeof record !== 'object' || record === null) return undefined;

    const value: unknown = Reflect.get(record, field);

    return typeof value === 'string' || typeof value === 'number'
        ? String(value)
        : undefined;
};

/** Возвращает связанные данные записи списка */
export const getRelatedRecord = (record: object, field: string): unknown => Reflect.get(record, field);
